import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from "react";
import { FilePond, registerPlugin } from "react-filepond";
import "filepond/dist/filepond.min.css";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginFileValidateSize from "filepond-plugin-file-validate-size";
import ProfilePhotoService from "../../services/ProfilePhotoService";
import UploadProgressBar from "./UploadProgressBar";
import { getXSRF } from "../../src/Services/Shared/FetchService";
registerPlugin(FilePondPluginFileValidateSize);
registerPlugin(FilePondPluginFileValidateType);
class ProfilePhotoUpload extends Component {
    constructor() {
        // @ts-expect-error - TS2554 - Expected 1-2 arguments, but got 0.
        super();
        this.getProgress = () => {
            const { startRequest } = this.state;
            if (this.state.startRequest) {
                this.setState({ startRequest: false });
            }
            ProfilePhotoService.getProfilePhotoCurrentStatus({ startRequest }).then((response) => {
                this.setState({
                    // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                    currentProcessStatus: response.currentProcessStatus,
                    // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                    profilePhotoStatus: response.profilePhotoStatus,
                    // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                    uiText: response.uiText,
                    processingStarted: true,
                });
                // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                if (response.profilePhotoStatus === "LOADING") {
                    setTimeout(this.getProgress, 500);
                }
            });
        };
        this.state = {
            fileAdded: false,
            uploadAborted: false,
            currentProcessStatus: 0,
            profilePhotoStatus: "LOADING",
            uiText: "Loading...",
            startRequest: true,
            uploadCompleted: false,
            processingStarted: false,
        };
    }
    render() {
        const { uploadCompleted, processingStarted, profilePhotoStatus } = this.state;
        const shouldShowProcessing = uploadCompleted || processingStarted;
        const finalStatus = uploadCompleted && profilePhotoStatus !== "LOADING" ? profilePhotoStatus : "LOADING";
        return (_jsxs("div", { className: "container-fluid pb-3 pt-3", children: [_jsx("div", { className: "title-block", children: _jsx("h1", { className: "title", children: "Upload Profile Photos" }) }), _jsxs("div", { className: "form-group", children: [_jsx(FilePond, { acceptedFileTypes: [
                                "application/zip",
                                "application/x-zip-compressed",
                            ], maxFileSize: "100MB", allowMultiple: false, server: {
                                url: "/aviso/profilePhoto/update",
                                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                // @ts-ignore
                                process: {
                                    headers: {
                                        "X-XSRF-TOKEN": getXSRF(),
                                    },
                                },
                            }, labelFileProcessingError: "Unable to upload file. Please make sure format is correct.", allowRevert: false, onprocessfileabort: () => this.setState({
                                profilePhotoStatus: "ABORT",
                                uploadAborted: true,
                            }), onprocessfiles: () => {
                                // FilePond upload completed
                                this.setState({
                                    uploadCompleted: true,
                                });
                            }, onaddfile: () => {
                                this.setState({
                                    fileAdded: true,
                                    uploadAborted: false,
                                    startRequest: true,
                                    uploadCompleted: false,
                                    processingStarted: false,
                                });
                                // Start polling with delay to avoid race condition
                                setTimeout(this.getProgress, 300);
                            }, labelTapToCancel: "" }), _jsxs("small", { className: "text-muted", children: ["Requirements for file upload:", _jsx("br", {}), "1. Must be a file ending in the .zip format.", _jsx("br", {}), "2. Must be less than 100 MB.", _jsx("br", {}), "3. Pictures must be in .jpg or .png format.", _jsx("br", {}), "4. Picture filenames must be alphanumeric only (letters and numbers). Ex: 0123456.png, ABC123.jpg", _jsx("br", {}), "5. All files in the zip must be valid. Upload will fail if any file is invalid."] })] }), this.state.fileAdded && !this.state.uploadAborted && shouldShowProcessing && (_jsx(UploadProgressBar, { info: this.state.uiText, barValue: this.state.currentProcessStatus, status: finalStatus }))] }));
    }
}
export default ProfilePhotoUpload;
